import cn from 'classnames';

import Button from 'components/button/Button';
import MenuSearch from './MenuSearch';
import Modal from 'components/modal/Modal';
import NavigationGroup from './NavigationGroup';

import { IMenu } from 'source/NFR.types';

interface MenuProps extends IMenu {
  closeMenu?: () => void;
  isOpen?: boolean;
}

const Menu: React.FC<MenuProps> = ({
  closeMenu,
  closeButtonText,
  globalSearch,
  id,
  isOpen,
  headerLinkList,
  navigationGroups = []
}) => {
  return (
    <Modal className="menu--wrapper" hideModal={closeMenu} id={id} isVisible={isOpen}>
      <div className={cn('menu', { 'menu--is-open': isOpen })}>
        <div className="menu--content">
          <div className="menu--header">
            <Button
              className="menu--close"
              iconBeforeChildren="x"
              onClick={closeMenu}
              title={closeButtonText}
              aria-controls={id}
              aria-expanded={isOpen}
            />
          </div>
          {globalSearch && globalSearch.input && <MenuSearch {...globalSearch} />}
          <nav>
            {headerLinkList && (
              <NavigationGroup
                className="menu--header-link-list"
                items={headerLinkList?.map(link => ({
                  link: {
                    ...link,
                    ...(link.isExternal ? { useSkinnyIcon: true } : { icon: 'change' })
                  }
                }))}
              />
            )}
            {navigationGroups?.map((group, index) => (
              <NavigationGroup key={group.title + String(index)} {...group} />
            ))}
          </nav>
        </div>
      </div>
    </Modal>
  );
};

Menu.displayName = 'Menu';

export default Menu;
